/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-19 18:18:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-17 17:32:05
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/reduxFunctions.ts
 */
import arrayMove from 'array-move';
import { moduleTypeHasChanged } from 'src/constrains/DraggableModules/tools';
import { hasItemList } from 'src/pages/SalesChannelContentEditor/common';
import { AllTypes, instanceType } from 'src/tools/helper';
import { ActionType } from 'src/types/common/common';
//import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash';
import {
  generateResponsiveModuleStyle,
  generateResponsiveText,
} from 'src/constrains/DraggableModules/tools';
import { onCollapseOpen as _onCollapseOpen } from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
import { isNumber, randomNumber } from 'src/tools/helper';
import { EnumModuleType } from 'src/types/common/module';

const handleOnModuleReset = (state, action) => {
  state.hasModified = true;
  const nId = randomNumber();
  const draggableId = action.payload;

  const _static = {
    ...(state.moduleContentStaticConfig[draggableId] || {}),
    uuid: null,
    draggableId: nId,
  };

  const { moduleType } = _static;

  const moduleStyle = generateResponsiveModuleStyle();
  const moduleText = generateResponsiveText();
  switch (moduleType) {
    case EnumModuleType.ResponsiveProductCarousel: {
      state.moduleContentStaticConfig[draggableId].moduleStyle = moduleStyle;
      state.moduleContentStaticConfig[draggableId].moduleText = moduleText;
      break;
    }
    case EnumModuleType.ResponsiveImageCarousel: {
      state.moduleContentStaticConfig[draggableId].moduleStyle = moduleStyle;
      state.moduleContentStaticConfig[draggableId].moduleText = moduleText;
      break;
    }
    case EnumModuleType.ResponsiveContentCarousel: {
      state.moduleContentStaticConfig[draggableId].moduleStyle = moduleStyle;
      state.moduleContentStaticConfig[draggableId].moduleText = moduleText;
      break;
    }
    case EnumModuleType.ResponsiveSubscription: {
      break;
    }
    case EnumModuleType.ResponsiveText: {
      break;
    }
    case EnumModuleType.ResponsivePoster: {
      state.moduleContentStaticConfig[draggableId].moduleStyle = moduleStyle;
      state.moduleContentStaticConfig[draggableId].moduleText = moduleText;
      break;
    }
    case EnumModuleType.ResponsiveProductGrid: {
      state.moduleContentStaticConfig[draggableId].moduleStyle = moduleStyle;
      state.moduleContentStaticConfig[draggableId].moduleText = moduleText;
      break;
    }
    case EnumModuleType.ResponsiveContentGrid: {
      state.moduleContentStaticConfig[draggableId].moduleStyle = moduleStyle;
      state.moduleContentStaticConfig[draggableId].moduleText = moduleText;
      break;
    }
    case EnumModuleType.ResponsiveProductTab: {
      state.moduleContentStaticConfig[draggableId].moduleStyle = moduleStyle;
      state.moduleContentStaticConfig[draggableId].moduleText = moduleText;
      break;
    }
    case EnumModuleType.ResponsiveContentTab: {
      state.moduleContentStaticConfig[draggableId].moduleStyle = moduleStyle;
      state.moduleContentStaticConfig[draggableId].moduleText = moduleText;
      break;
    }
    case EnumModuleType.ResponsivePosterTab: {
      state.moduleContentStaticConfig[draggableId].moduleStyle = moduleStyle;
      state.moduleContentStaticConfig[draggableId].moduleText = moduleText;
      break;
    }

    default:
      break;
  }

  //state.moduleContentDynamicConfig[nId] = _open;

  //state.collapseErrorMsgDisplay[id];
};

const handleOnModuleDuplicate = (state, action) => {
  state.hasModified = true;
  const nId = randomNumber();
  const draggableId = action.payload;

  const _static = {
    ...(state.moduleContentStaticConfig[draggableId] || {}),
    uuid: null,
    draggableId: nId,
  };

  const { moduleType } = _static;

  const _dynamic = state.moduleContentDynamicConfig[draggableId];

  state.moduleContentStaticConfig[nId] = _static;
  state.moduleContentDynamicConfig[nId] = _dynamic;
  state.collapseErrorMsgDisplay[nId] = { hasError: false, display: false };
  state.collapseOpen[nId] = false;
  state.moduleContentOrder.push({ moduleType, draggableId: nId });
  _onCollapseOpen(state, [nId]);

  //state.moduleContentDynamicConfig[nId] = _open;

  //state.collapseErrorMsgDisplay[id];
};

const moduleContentOnChange = (state, action) => {
  state.hasModified = true;
  const { type, id, data } = action.payload;
  switch (type) {
    case ActionType.delete: {
      delete state.moduleContentStaticConfig[id];
      delete state.moduleContentDynamicConfig[id];
      deleteDraggableCollapse(state, id);
      const index = state.moduleContentOrder.findIndex(
        (i) => i.draggableId === id,
      );
      if (instanceType(index) === AllTypes.Number) {
        state.moduleContentOrder.splice(index, 1);
      }

      return;
    }

    case ActionType.add: {
      const { initialStaticData, initialDynamicData } = data;

      const { draggableId, moduleType } = initialStaticData;
      const _hasDynamic = hasItemList.includes(moduleType);
      if (_hasDynamic) {
        state.moduleContentDynamicConfig[draggableId] = initialDynamicData;
      }
      state.moduleContentStaticConfig[draggableId] = initialStaticData;
      state.moduleContentOrder.push({ draggableId, moduleType });

      addDraggableCollapse(state, draggableId);
      return;
    }

    case ActionType.reorder: {
      const { from, to } = data;
      state.moduleContentOrder = arrayMove(state.moduleContentOrder, from, to);
      return;
    }

    // case ActionType.reselect: {
    //   const { moduleType } = data;
    //   const { staticData, dynamicData } = moduleTypeHasChanged(moduleType);
    //   const { visible, moduleName } = state.moduleContentStaticConfig[id];
    //   state.moduleContentStaticConfig[id] = {
    //     ...staticData,
    //     visible,
    //     moduleName,
    //   };
    //   state.moduleContentDynamicConfig[id] = dynamicData;
    //   // const { from, to } = data;
    //   // state.moduleContentOrder = arrayMove(state.moduleContentOrder, from, to);
    //   return;
    // }

    default:
      return;
  }
};

const deleteDraggableCollapse = (state, id) => {
  delete state.collapseOpen[id];
  delete state.collapseErrorMsgDisplay[id];
};

const addDraggableCollapse = (state, draggableId) => {
  for (const i in state.collapseOpen) {
    if (state.collapseOpen[i]) {
      state.collapseOpen[i] = false;
      state.collapseErrorMsgDisplay[i].display = true;
    }
  }
  state.collapseOpen[draggableId] = true;
  state.collapseErrorMsgDisplay[draggableId] = {
    hasError: false,
    display: false,
  };
};

const constantKeys = ['switcherType', 'selectedTab'];

const moduleContentStaticOnChange = (state, action) => {
  const { id, data } = action.payload;
  if (
    Object.keys(data).length === 1 &&
    constantKeys.includes(Object.keys(data)[0])
  ) {
    //state.hasModified = true;
  } else {
    state.hasModified = true;
  }

  Object.keys(data).forEach((i) => {
    state.moduleContentStaticConfig[`${id}`][i] = data[i];
  });
};

const onModuleTypeChange = (state, data) => {
  state.hasModified = true;

  const { moduleType, id } = data;

  state.moduleContentOrder = state.moduleContentOrder.reduce((pre, now) => {
    const { draggableId } = now;

    if (draggableId === id) {
      return [
        ...pre,
        {
          moduleType,
          draggableId: id,
        },
      ];
    } else {
      return [...pre, now];
    }
  }, []);

  const { staticData, dynamicData } = moduleTypeHasChanged(moduleType);
  //console.log('changed', staticData, dynamicData);
  const { visible, moduleName } = state.moduleContentStaticConfig[id];
  //console.log('staticData', staticData);
  state.moduleContentStaticConfig[id] = {
    ...staticData,
    draggableId: id,
    visible,
    moduleName,
  };

  state.moduleContentDynamicConfig[id] = dynamicData;
};

const moduleContentDynamicOnChange = (state, action) => {
  state.hasModified = true;
  const { type, id, data, category } = action.payload;

  switch (type) {
    case ActionType.reselect: {
      if (category) {
        state.moduleContentDynamicConfig[id][category] = data;
      } else {
        state.moduleContentDynamicConfig[id] = data;
      }
      return;
    }

    case ActionType.delete: {
      const { index } = data;
      if (category) {
        state.moduleContentDynamicConfig[id][category].splice(index, 1);
      } else {
        state.moduleContentDynamicConfig[id].splice(index, 1);
      }

      return;
    }

    case ActionType.deleteAll: {
      if (category) {
        state.moduleContentDynamicConfig[id][category] = data;
      } else {
        state.moduleContentDynamicConfig[id] = data;
      }
      return;
    }

    case ActionType.add: {
      if (category) {
        state.moduleContentDynamicConfig[id][category].push(...data);
      } else {
        state.moduleContentDynamicConfig[id].push(...data);
      }

      return;
    }

    case ActionType.modify: {
      const { index, modifiedData = {} } = data;
      if (category) {
        Object.keys(modifiedData).forEach((i) => {
          state.moduleContentDynamicConfig[id][category][index][i] =
            modifiedData[i];
        });
      } else {
        Object.keys(modifiedData).forEach((i) => {
          state.moduleContentDynamicConfig[id][index][i] = modifiedData[i];
        });
      }

      return;
    }

    case ActionType.reorder: {
      const { from, to } = data;
      if (category) {
        state.moduleContentDynamicConfig[id][category] = arrayMove(
          state.moduleContentDynamicConfig[id][category],
          from,
          to,
        );
      } else {
        state.moduleContentDynamicConfig[id] = arrayMove(
          state.moduleContentDynamicConfig[id],
          from,
          to,
        );
      }

      return;
    }

    default:
      //console.log('default');
      return;
  }
};

const visibleModuleCheck = (state) => {
  if (Object.keys(state.moduleContentStaticConfig).length === 0) {
    state.isDataValid = false;
  }
  const _hasVisibleModule = Object.values(state.moduleContentStaticConfig).find(
    (i: any) => i.visible,
  );
  if (!_hasVisibleModule) {
    state.isDataValid = false;
  }
};

function handleOnContentListResponsiveLayerEditSubmit(state, action) {
  state.hasModified = true;
  const { from, data, isSubmitting, additionalData } = action.payload;

  const isPosterTab =
    get(additionalData, 'sourceType') === EnumModuleType.ResponsivePosterTab;

  const { contentListId, imageId } = from;
  if (isPosterTab) {
    const tabId = get(additionalData, 'tabId');

    const target = state.moduleContentDynamicConfig[contentListId];
    // console.log('target', target);
    const tabIndex = target.findIndex((i) => i.draggableId === tabId);

    const posters = get(target, `${tabIndex}.posters`) || [];
    const posterIndex = posters.findIndex((i) => i.draggableId === imageId);

    if (isNumber(posterIndex)) {
      state.moduleContentDynamicConfig[contentListId][tabIndex].posters[
        posterIndex
      ] = data;
      //
      if (!isSubmitting) _onCollapseOpen(state, [contentListId]);
    }
  } else {
    const target = state.moduleContentDynamicConfig[contentListId];
    const index = target.findIndex((i) => i.draggableId === imageId);
    // console.log('index', index);
    if (isNumber(index)) {
      state.moduleContentDynamicConfig[contentListId][index] = data;
      //
      if (!isSubmitting) _onCollapseOpen(state, [contentListId]);
    }
  }
}

export {
  moduleContentOnChange,
  moduleContentStaticOnChange,
  moduleContentDynamicOnChange,
  visibleModuleCheck,
  onModuleTypeChange,
  addDraggableCollapse,
  deleteDraggableCollapse,
  handleOnContentListResponsiveLayerEditSubmit,
  handleOnModuleDuplicate,
  handleOnModuleReset,
};
